import React, { useEffect, useState } from 'react';
import { ChartContent } from './ChartContent';
import { LineGraph } from './LineGraph';
import { colors } from '../../../../theme/palette';
import { ButtonClickData } from '../../../../store/models/analytics/ButtonClicks';

export interface ButtonClicksProps {
	data: ButtonClickData[];
}

export const ButtonClicks = (props: ButtonClicksProps) => {
	const { data } = { ...props };
	const [selected, setSelected] = useState('');
	const [clicks, setClicks] = useState([]);
	const [total, setTotal] = useState(0);
	const [buttonNames, setButtonNames] = useState({});

	useEffect(() => {
		// if buttonNames object isnt populated yet, but the data object is, then populate buttonNames
		if (!Object.keys(buttonNames).length && data.length) {
			const tempButtonNames = {};
			data.forEach((button) => {
				tempButtonNames[button.buttonId] = button.buttonName;
			});
			setButtonNames(tempButtonNames);
			// Set the first button as selected if none is selected
			if (!selected && data.length > 0) {
				setSelected(data[0].buttonId);
			}
		}
	}, [data, buttonNames, selected]);

	useEffect(() => {
		// if buttonNames object is populated, then set the clicks and total
		if (Object.keys(buttonNames).length > 0 && selected) {
			const selectedButton = data.find((button) => button.buttonId === selected);
			if (selectedButton) {
				setClicks(selectedButton.clicks);
				const tempTotal = selectedButton.clicks?.reduce((acc, click) => acc + click.value, 0) || 0;
				setTotal(tempTotal);
			} else {
				// If no data for selected button, set empty values
				setClicks([]);
				setTotal(0);
			}
		}
	}, [selected, data, buttonNames]);

	return (
		<ChartContent
			name={'BUTTON/HYPERLINK CLICK TOTALS'}
			selected={selected}
			pageNames={buttonNames}
			setSelected={setSelected}
			total={total}
			toolTipMsg={
				'The number of clicks for the selected button. Change buttons using the button selector in the top right of the Button Clicks card.'
			}
			clickStats={true}
		>
			<LineGraph width="100%" height={230} data={clicks} name="Clicks" color={colors.tealAccent} />
		</ChartContent>
	);
};
